// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GoalItem-module__font-s-10___rHXS3 {
  font-size: 10px !important;
}

.GoalItem-module__font-s-12___ogtcj {
  font-size: 12px !important;
}

.GoalItem-module__font-s-13___W6DZY {
  font-size: 13px !important;
}

.GoalItem-module__font-s-14___eShS1 {
  font-size: 14px !important;
}

.GoalItem-module__font-s-15___SOZiy {
  font-size: 15px !important;
}

.GoalItem-module__font-s-16___V8UpN {
  font-size: 16px !important;
}

.GoalItem-module__font-s-18___b6j28 {
  font-size: 18px !important;
}

.GoalItem-module__font-s-20___cxl8P {
  font-size: 20px !important;
}

.GoalItem-module__font-s-22___j3weK {
  font-size: 22px !important;
}

.GoalItem-module__font-s-28___rgrPD {
  font-size: 28px !important;
}

.GoalItem-module__font-w-400___VGIic {
  font-weight: 400 !important;
}

.GoalItem-module__font-w-500___NSHys {
  font-weight: 500 !important;
}

.GoalItem-module__font-w-600___L5kgI {
  font-weight: 600 !important;
}

.GoalItem-module__font-w-700___H1dkj {
  font-weight: 700 !important;
}

.GoalItem-module__p-5___lu4U7 {
  padding: 5px !important;
}

.GoalItem-module__p-12___ooAjx {
  padding: 12px !important;
}

.GoalItem-module__p-16___ycOZg {
  padding: 16px !important;
}

.GoalItem-module__p-30____Lso7 {
  padding: 30px !important;
}

.GoalItem-module__p-b-0___Pi2Lm {
  padding-bottom: 0 !important;
}

.GoalItem-module__p-b-5___Si0Jd {
  padding-bottom: 5px !important;
}

.GoalItem-module__p-b-10___vA9Ka {
  padding-bottom: 10px !important;
}

.GoalItem-module__p-b-12___Uu2KA {
  padding-bottom: 12px !important;
}

.GoalItem-module__p-b-16___FgO49 {
  padding-bottom: 16px !important;
}

.GoalItem-module__p-b-18___nWcqz {
  padding-bottom: 18px !important;
}

.GoalItem-module__p-b-20___ylMUX {
  padding-bottom: 20px !important;
}

.GoalItem-module__p-b-25___LAfCo {
  padding-bottom: 25px !important;
}

.GoalItem-module__p-b-30___q_7Px {
  padding-bottom: 30px !important;
}

.GoalItem-module__p-b-50___tAz0e {
  padding-bottom: 50px !important;
}

.GoalItem-module__p-t-0___Y5c37 {
  padding-top: 0 !important;
}

.GoalItem-module__p-t-12___F5IAw {
  padding-top: 12px !important;
}

.GoalItem-module__p-t-16___n3iHi {
  padding-top: 16px !important;
}

.GoalItem-module__p-t-18___ZsppB {
  padding-top: 18px !important;
}

.GoalItem-module__p-t-20___Wi3rv {
  padding-top: 20px !important;
}

.GoalItem-module__p-t-30___AACry {
  padding-top: 30px !important;
}

.GoalItem-module__p-t-40___ZMFRs {
  padding-top: 40px !important;
}

.GoalItem-module__p-t-50___sivqq {
  padding-top: 50px !important;
}

.GoalItem-module__p-l-20___Kbizc {
  padding-left: 20px !important;
}

.GoalItem-module__p-l-30___tdn4J {
  padding-left: 30px !important;
}

.GoalItem-module__p-l-40___AIuBW {
  padding-left: 40px !important;
}

.GoalItem-module__p-r-16___DYGgj {
  padding-right: 16px !important;
}

.GoalItem-module__p-r-20___tIQGB {
  padding-right: 20px !important;
}

.GoalItem-module__p-r-30___pQk2N {
  padding-right: 30px !important;
}

.GoalItem-module__p-r-50___kFnpY {
  padding-right: 50px !important;
}

.GoalItem-module__p-r-60___VqmYw {
  padding-right: 60px !important;
}

.GoalItem-module__m-b-1___HhFrV {
  margin-bottom: 1px !important;
}

.GoalItem-module__m-b-2___bXTgB {
  margin-bottom: 2px !important;
}

.GoalItem-module__m-b-6___NmqqM {
  margin-bottom: 6px !important;
}

.GoalItem-module__m-b-8___nTO0j {
  margin-bottom: 8px !important;
}

.GoalItem-module__m-b-10___VrDc6 {
  margin-bottom: 10px !important;
}

.GoalItem-module__m-b-14___BVjsk {
  margin-bottom: 14px !important;
}

.GoalItem-module__m-b-16___lOorO {
  margin-bottom: 16px !important;
}

.GoalItem-module__m-b-20___eVXO8 {
  margin-bottom: 20px !important;
}

.GoalItem-module__m-b-22___JG6fy {
  margin-bottom: 22px !important;
}

.GoalItem-module__m-b-24____Qtbr {
  margin-bottom: 24px !important;
}

.GoalItem-module__m-b-30___kM1w5 {
  margin-bottom: 30px !important;
}

.GoalItem-module__m-b-32___bt3Mp {
  margin-bottom: 32px !important;
}

.GoalItem-module__m-b-40___gDbql {
  margin-bottom: 40px !important;
}

.GoalItem-module__m-t-2___KsKzd {
  margin-top: 2px !important;
}

.GoalItem-module__m-t-3___xXb8X {
  margin-top: 3px !important;
}

.GoalItem-module__m-t-4___mmUyu {
  margin-top: 4px !important;
}

.GoalItem-module__m-t-5___LY6CD {
  margin-top: 5px !important;
}

.GoalItem-module__m-t-8___MggIh {
  margin-top: 8px !important;
}

.GoalItem-module__m-t-10___jzbC7 {
  margin-top: 10px !important;
}

.GoalItem-module__m-t-15___KY66B {
  margin-top: 15px !important;
}

.GoalItem-module__m-t-16___ZyGlz {
  margin-top: 16px !important;
}

.GoalItem-module__m-t-20___NgHhJ {
  margin-top: 20px !important;
}

.GoalItem-module__m-t-22____eIxR {
  margin-top: 22px !important;
}

.GoalItem-module__m-t-30___QZXl1 {
  margin-top: 30px !important;
}

.GoalItem-module__m-t-32___Ok8kE {
  margin-top: 32px !important;
}

.GoalItem-module__m-l-auto___OmwE2 {
  margin-left: auto !important;
}

.GoalItem-module__m-l-4___azm_4 {
  margin-left: 4px !important;
}

.GoalItem-module__m-l-5___D7UMm {
  margin-left: 5px !important;
}

.GoalItem-module__m-l-6___oa3oJ {
  margin-left: 6px !important;
}

.GoalItem-module__m-l-8___azcGG {
  margin-left: 8px !important;
}

.GoalItem-module__m-l-10___e6Cyj {
  margin-left: 10px !important;
}

.GoalItem-module__m-l-16___GQiy3 {
  margin-left: 16px !important;
}

.GoalItem-module__m-l-20___GyNHA {
  margin-left: 20px !important;
}

.GoalItem-module__m-l-24___sgBcG {
  margin-left: 24px !important;
}

.GoalItem-module__m-l-30___JLojc {
  margin-left: 30px !important;
}

.GoalItem-module__m-l-35___D3c84 {
  margin-left: 35px !important;
}

.GoalItem-module__m-l-40___UMhZt {
  margin-left: 40px !important;
}

.GoalItem-module__m-r-8___S8u8g {
  margin-right: 8px !important;
}

.GoalItem-module__m-r-10___ZbhTw {
  margin-right: 10px !important;
}

.GoalItem-module__m-r-16___Z7qhb {
  margin-right: 16px !important;
}

.GoalItem-module__m-r-20___ttA6a {
  margin-right: 20px !important;
}

.GoalItem-module__m-r-24___Pb_xN {
  margin-right: 24px !important;
}

.GoalItem-module__m-r-30___h0HHB {
  margin-right: 30px !important;
}

.GoalItem-module__m-r-40___MaBcc {
  margin-right: 40px !important;
}

.GoalItem-module__border-r-3___mPMDu {
  border-radius: 3px !important;
}

.GoalItem-module__border-r-4___Lrxek {
  border-radius: 4px !important;
}

.GoalItem-module__border-r-6___f3ZXc {
  border-radius: 6px !important;
}

.GoalItem-module__border-r-10___cDENE {
  border-radius: 10px !important;
}

.GoalItem-module__border-r-12___ofJ6Q {
  border-radius: 12px !important;
}

.GoalItem-module__border-r-16___tpdow {
  border-radius: 16px !important;
}

.GoalItem-module__border-r-50___lJh9F {
  border-radius: 50% !important;
}

.GoalItem-module__primary-border___szUYV {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.GoalItem-module__primary-border-b___DiWY1 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.GoalItem-module__primary-border-t___fGaG4 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.GoalItem-module__primary-border-l___n8j2P {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.GoalItem-module__primary-border-r___RyHgF {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.GoalItem-module__secondary-border___zzdDX {
  border: 1px solid #637768;
}

.GoalItem-module__secondary-border-b___uA60X {
  border-bottom: 1px solid #637768;
}

.GoalItem-module__secondary-border-t___udFHm {
  border-top: 1px solid #637768;
}

.GoalItem-module__secondary-border-l___J1o4P {
  border-left: 1px solid #637768;
}

.GoalItem-module__secondary-border-r___TAPwF {
  border-right: 1px solid #637768;
}

.GoalItem-module__gap-0___mODja {
  gap: 0 !important;
}

.GoalItem-module__gap-2___lt24E {
  gap: 2px !important;
}

.GoalItem-module__gap-4___wbJVb {
  gap: 4px !important;
}

.GoalItem-module__gap-5___MwmwS {
  gap: 5px !important;
}

.GoalItem-module__gap-6___f3jeQ {
  gap: 6px !important;
}

.GoalItem-module__gap-8___g2BiK {
  gap: 8px !important;
}

.GoalItem-module__gap-10___DWIm1 {
  gap: 10px !important;
}

.GoalItem-module__gap-12___RFWjr {
  gap: 12px !important;
}

.GoalItem-module__gap-14___b8s9v {
  gap: 14px !important;
}

.GoalItem-module__gap-16___tvfqv {
  gap: 16px !important;
}

.GoalItem-module__gap-18___hX16b {
  gap: 18px !important;
}

.GoalItem-module__gap-20___UGWqj {
  gap: 20px !important;
}

.GoalItem-module__gap-24___g6hRJ {
  gap: 24px !important;
}

.GoalItem-module__gap-26___rtY8g {
  gap: 26px !important;
}

.GoalItem-module__gap-30___qmQ1L {
  gap: 30px !important;
}

.GoalItem-module__gap-32___HiAFB {
  gap: 32px !important;
}

.GoalItem-module__gap-40___go4rk {
  gap: 40px !important;
}

.GoalItem-module__gap-50___fvW8i {
  gap: 50px !important;
}

.GoalItem-module__flex-1___qs51F {
  flex: 1;
}

.GoalItem-module__flex-none___uuEVP {
  flex: none !important;
}

.GoalItem-module__flex-column___xNZwy {
  display: flex;
  flex-direction: column !important;
}

.GoalItem-module__flex-row___mZjSY {
  display: flex;
  flex-direction: row !important;
}

.GoalItem-module__vertically-centered___hyHvS {
  display: flex;
  align-items: center !important;
}

.GoalItem-module__horizontally-centered___sT_Ci {
  display: flex;
  justify-content: center !important;
}

.GoalItem-module__horizontally-end___TDFyw {
  display: flex;
  justify-content: end !important;
}

.GoalItem-module__vertically-start___zEewn {
  display: flex;
  align-items: start !important;
}

.GoalItem-module__space-between___O_aWS {
  display: flex;
  justify-content: space-between !important;
}

.GoalItem-module__flex-wrap___D7cqs {
  flex-wrap: wrap !important;
}

.GoalItem-module__height-100___YQs2B {
  height: 100%;
}

.GoalItem-module__width-50___iK1Kq {
  width: 50% !important;
}

.GoalItem-module__width-100___hWCMa {
  width: 100%;
}

.GoalItem-module__cursor-pointer___mT4n1 {
  cursor: pointer;
}

.GoalItem-module__cursor-not-allowed___cLfFo {
  cursor: not-allowed !important;
}

.GoalItem-module__absolute-centered___F4rRC {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.GoalItem-module__absolute___HuQFT {
  position: absolute;
}

.GoalItem-module__relative___DT4wX {
  position: relative;
}

.GoalItem-module__fixed___fpbak {
  position: fixed;
}

.GoalItem-module__visible___bVuji {
  opacity: 1;
}

.GoalItem-module__invisible___swmoy {
  opacity: 0;
}

.GoalItem-module__col-90___EO9Im {
  width: 90% !important;
}

.GoalItem-module__col-auto___jqihR {
  width: auto !important;
}

.GoalItem-module__medical-tabs___u4Wxc {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.GoalItem-module__medical-table-new___YjVeo {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.GoalItem-module__medical-table-new___YjVeo:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.GoalItem-module__medical-table-new___YjVeo::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.GoalItem-module__medical-table-new___YjVeo::-webkit-scrollbar-track {
  display: none;
}
.GoalItem-module__medical-table-new___YjVeo.GoalItem-module__no-pagination___JvNJg {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.GoalItem-module__medical-table-new___YjVeo.GoalItem-module__no-pagination___JvNJg:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.GoalItem-module__medical-table-new___YjVeo.GoalItem-module__no-pagination___JvNJg::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.GoalItem-module__medical-table-new___YjVeo.GoalItem-module__no-pagination___JvNJg::-webkit-scrollbar-track {
  display: none;
}

.GoalItem-module__medical-table-empty___uY0vo {
  padding: 14px 40px !important;
}

.GoalItem-module__icon-btn___vTOEx {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.GoalItem-module__search-icon___sR48l {
  width: 24px;
  height: 24px;
  align-self: center;
}

.GoalItem-module__disable-select___nLLXE {
  user-select: none;
}

.GoalItem-module__break-word___Eayht {
  word-break: break-word;
}

.GoalItem-module__popup-clear-btn___N4rRt {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.GoalItem-module__scroll-m-b-20___BojHi {
  scroll-margin-bottom: 20px;
}

.GoalItem-module__container___FdK4B {
  flex: 1;
}
.GoalItem-module__container___FdK4B .GoalItem-module__title___TMCFK {
  height: 20px;
  width: 170px;
  font-family: var(--font-family);
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #375844;
  line-height: 150%;
  letter-spacing: -0.011em;
  text-decoration-line: underline;
}
.GoalItem-module__container___FdK4B .GoalItem-module__date___ncMIH {
  height: 20px;
  font-family: var(--font-family);
  font-weight: 400;
  color: #859989;
  line-height: 15px;
  letter-spacing: -0.011em;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/SmartGoals/SmartGoalsList/items/GoalItem/GoalItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;AA8pBF;AA5pBE;EACE,YAAA;EACA,YAAA;EEmBF,+BApBO;EAqBP,gBAFmD;EDrBnD,gBAAA;EACA,mBAAA;EACA,uBAAA;EDIE,cAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BAAA;AAiqBJ;AA9pBE;EACE,YAAA;EESF,+BApBO;EAqBP,gBAFmD;EFNjD,cAAA;EACA,iBAAA;EACA,wBAAA;AAiqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n\n  .title {\n    height: 20px;\n    width: 170px;\n    @include get-font($roboto);\n    @include clipped-text;\n    color: get-color(greenNew, dark);\n    line-height: 150%;\n    letter-spacing: -0.011em;\n    text-decoration-line: underline;\n  }\n\n  .date {\n    height: 20px;\n    @include get-font($roboto);\n    color: get-color(greenNew, medium);\n    line-height: 15px;\n    letter-spacing: -0.011em;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `GoalItem-module__font-s-10___rHXS3`,
	"fontS12": `GoalItem-module__font-s-12___ogtcj`,
	"fontS13": `GoalItem-module__font-s-13___W6DZY`,
	"fontS14": `GoalItem-module__font-s-14___eShS1`,
	"fontS15": `GoalItem-module__font-s-15___SOZiy`,
	"fontS16": `GoalItem-module__font-s-16___V8UpN`,
	"fontS18": `GoalItem-module__font-s-18___b6j28`,
	"fontS20": `GoalItem-module__font-s-20___cxl8P`,
	"fontS22": `GoalItem-module__font-s-22___j3weK`,
	"fontS28": `GoalItem-module__font-s-28___rgrPD`,
	"fontW400": `GoalItem-module__font-w-400___VGIic`,
	"fontW500": `GoalItem-module__font-w-500___NSHys`,
	"fontW600": `GoalItem-module__font-w-600___L5kgI`,
	"fontW700": `GoalItem-module__font-w-700___H1dkj`,
	"p5": `GoalItem-module__p-5___lu4U7`,
	"p12": `GoalItem-module__p-12___ooAjx`,
	"p16": `GoalItem-module__p-16___ycOZg`,
	"p30": `GoalItem-module__p-30____Lso7`,
	"pB0": `GoalItem-module__p-b-0___Pi2Lm`,
	"pB5": `GoalItem-module__p-b-5___Si0Jd`,
	"pB10": `GoalItem-module__p-b-10___vA9Ka`,
	"pB12": `GoalItem-module__p-b-12___Uu2KA`,
	"pB16": `GoalItem-module__p-b-16___FgO49`,
	"pB18": `GoalItem-module__p-b-18___nWcqz`,
	"pB20": `GoalItem-module__p-b-20___ylMUX`,
	"pB25": `GoalItem-module__p-b-25___LAfCo`,
	"pB30": `GoalItem-module__p-b-30___q_7Px`,
	"pB50": `GoalItem-module__p-b-50___tAz0e`,
	"pT0": `GoalItem-module__p-t-0___Y5c37`,
	"pT12": `GoalItem-module__p-t-12___F5IAw`,
	"pT16": `GoalItem-module__p-t-16___n3iHi`,
	"pT18": `GoalItem-module__p-t-18___ZsppB`,
	"pT20": `GoalItem-module__p-t-20___Wi3rv`,
	"pT30": `GoalItem-module__p-t-30___AACry`,
	"pT40": `GoalItem-module__p-t-40___ZMFRs`,
	"pT50": `GoalItem-module__p-t-50___sivqq`,
	"pL20": `GoalItem-module__p-l-20___Kbizc`,
	"pL30": `GoalItem-module__p-l-30___tdn4J`,
	"pL40": `GoalItem-module__p-l-40___AIuBW`,
	"pR16": `GoalItem-module__p-r-16___DYGgj`,
	"pR20": `GoalItem-module__p-r-20___tIQGB`,
	"pR30": `GoalItem-module__p-r-30___pQk2N`,
	"pR50": `GoalItem-module__p-r-50___kFnpY`,
	"pR60": `GoalItem-module__p-r-60___VqmYw`,
	"mB1": `GoalItem-module__m-b-1___HhFrV`,
	"mB2": `GoalItem-module__m-b-2___bXTgB`,
	"mB6": `GoalItem-module__m-b-6___NmqqM`,
	"mB8": `GoalItem-module__m-b-8___nTO0j`,
	"mB10": `GoalItem-module__m-b-10___VrDc6`,
	"mB14": `GoalItem-module__m-b-14___BVjsk`,
	"mB16": `GoalItem-module__m-b-16___lOorO`,
	"mB20": `GoalItem-module__m-b-20___eVXO8`,
	"mB22": `GoalItem-module__m-b-22___JG6fy`,
	"mB24": `GoalItem-module__m-b-24____Qtbr`,
	"mB30": `GoalItem-module__m-b-30___kM1w5`,
	"mB32": `GoalItem-module__m-b-32___bt3Mp`,
	"mB40": `GoalItem-module__m-b-40___gDbql`,
	"mT2": `GoalItem-module__m-t-2___KsKzd`,
	"mT3": `GoalItem-module__m-t-3___xXb8X`,
	"mT4": `GoalItem-module__m-t-4___mmUyu`,
	"mT5": `GoalItem-module__m-t-5___LY6CD`,
	"mT8": `GoalItem-module__m-t-8___MggIh`,
	"mT10": `GoalItem-module__m-t-10___jzbC7`,
	"mT15": `GoalItem-module__m-t-15___KY66B`,
	"mT16": `GoalItem-module__m-t-16___ZyGlz`,
	"mT20": `GoalItem-module__m-t-20___NgHhJ`,
	"mT22": `GoalItem-module__m-t-22____eIxR`,
	"mT30": `GoalItem-module__m-t-30___QZXl1`,
	"mT32": `GoalItem-module__m-t-32___Ok8kE`,
	"mLAuto": `GoalItem-module__m-l-auto___OmwE2`,
	"mL4": `GoalItem-module__m-l-4___azm_4`,
	"mL5": `GoalItem-module__m-l-5___D7UMm`,
	"mL6": `GoalItem-module__m-l-6___oa3oJ`,
	"mL8": `GoalItem-module__m-l-8___azcGG`,
	"mL10": `GoalItem-module__m-l-10___e6Cyj`,
	"mL16": `GoalItem-module__m-l-16___GQiy3`,
	"mL20": `GoalItem-module__m-l-20___GyNHA`,
	"mL24": `GoalItem-module__m-l-24___sgBcG`,
	"mL30": `GoalItem-module__m-l-30___JLojc`,
	"mL35": `GoalItem-module__m-l-35___D3c84`,
	"mL40": `GoalItem-module__m-l-40___UMhZt`,
	"mR8": `GoalItem-module__m-r-8___S8u8g`,
	"mR10": `GoalItem-module__m-r-10___ZbhTw`,
	"mR16": `GoalItem-module__m-r-16___Z7qhb`,
	"mR20": `GoalItem-module__m-r-20___ttA6a`,
	"mR24": `GoalItem-module__m-r-24___Pb_xN`,
	"mR30": `GoalItem-module__m-r-30___h0HHB`,
	"mR40": `GoalItem-module__m-r-40___MaBcc`,
	"borderR3": `GoalItem-module__border-r-3___mPMDu`,
	"borderR4": `GoalItem-module__border-r-4___Lrxek`,
	"borderR6": `GoalItem-module__border-r-6___f3ZXc`,
	"borderR10": `GoalItem-module__border-r-10___cDENE`,
	"borderR12": `GoalItem-module__border-r-12___ofJ6Q`,
	"borderR16": `GoalItem-module__border-r-16___tpdow`,
	"borderR50": `GoalItem-module__border-r-50___lJh9F`,
	"primaryBorder": `GoalItem-module__primary-border___szUYV`,
	"primaryBorderB": `GoalItem-module__primary-border-b___DiWY1`,
	"primaryBorderT": `GoalItem-module__primary-border-t___fGaG4`,
	"primaryBorderL": `GoalItem-module__primary-border-l___n8j2P`,
	"primaryBorderR": `GoalItem-module__primary-border-r___RyHgF`,
	"secondaryBorder": `GoalItem-module__secondary-border___zzdDX`,
	"secondaryBorderB": `GoalItem-module__secondary-border-b___uA60X`,
	"secondaryBorderT": `GoalItem-module__secondary-border-t___udFHm`,
	"secondaryBorderL": `GoalItem-module__secondary-border-l___J1o4P`,
	"secondaryBorderR": `GoalItem-module__secondary-border-r___TAPwF`,
	"gap0": `GoalItem-module__gap-0___mODja`,
	"gap2": `GoalItem-module__gap-2___lt24E`,
	"gap4": `GoalItem-module__gap-4___wbJVb`,
	"gap5": `GoalItem-module__gap-5___MwmwS`,
	"gap6": `GoalItem-module__gap-6___f3jeQ`,
	"gap8": `GoalItem-module__gap-8___g2BiK`,
	"gap10": `GoalItem-module__gap-10___DWIm1`,
	"gap12": `GoalItem-module__gap-12___RFWjr`,
	"gap14": `GoalItem-module__gap-14___b8s9v`,
	"gap16": `GoalItem-module__gap-16___tvfqv`,
	"gap18": `GoalItem-module__gap-18___hX16b`,
	"gap20": `GoalItem-module__gap-20___UGWqj`,
	"gap24": `GoalItem-module__gap-24___g6hRJ`,
	"gap26": `GoalItem-module__gap-26___rtY8g`,
	"gap30": `GoalItem-module__gap-30___qmQ1L`,
	"gap32": `GoalItem-module__gap-32___HiAFB`,
	"gap40": `GoalItem-module__gap-40___go4rk`,
	"gap50": `GoalItem-module__gap-50___fvW8i`,
	"flex1": `GoalItem-module__flex-1___qs51F`,
	"flexNone": `GoalItem-module__flex-none___uuEVP`,
	"flexColumn": `GoalItem-module__flex-column___xNZwy`,
	"flexRow": `GoalItem-module__flex-row___mZjSY`,
	"verticallyCentered": `GoalItem-module__vertically-centered___hyHvS`,
	"horizontallyCentered": `GoalItem-module__horizontally-centered___sT_Ci`,
	"horizontallyEnd": `GoalItem-module__horizontally-end___TDFyw`,
	"verticallyStart": `GoalItem-module__vertically-start___zEewn`,
	"spaceBetween": `GoalItem-module__space-between___O_aWS`,
	"flexWrap": `GoalItem-module__flex-wrap___D7cqs`,
	"height100": `GoalItem-module__height-100___YQs2B`,
	"width50": `GoalItem-module__width-50___iK1Kq`,
	"width100": `GoalItem-module__width-100___hWCMa`,
	"cursorPointer": `GoalItem-module__cursor-pointer___mT4n1`,
	"cursorNotAllowed": `GoalItem-module__cursor-not-allowed___cLfFo`,
	"absoluteCentered": `GoalItem-module__absolute-centered___F4rRC`,
	"absolute": `GoalItem-module__absolute___HuQFT`,
	"relative": `GoalItem-module__relative___DT4wX`,
	"fixed": `GoalItem-module__fixed___fpbak`,
	"visible": `GoalItem-module__visible___bVuji`,
	"invisible": `GoalItem-module__invisible___swmoy`,
	"col90": `GoalItem-module__col-90___EO9Im`,
	"colAuto": `GoalItem-module__col-auto___jqihR`,
	"medicalTabs": `GoalItem-module__medical-tabs___u4Wxc`,
	"medicalTableNew": `GoalItem-module__medical-table-new___YjVeo`,
	"noPagination": `GoalItem-module__no-pagination___JvNJg`,
	"medicalTableEmpty": `GoalItem-module__medical-table-empty___uY0vo`,
	"iconBtn": `GoalItem-module__icon-btn___vTOEx`,
	"searchIcon": `GoalItem-module__search-icon___sR48l`,
	"disableSelect": `GoalItem-module__disable-select___nLLXE`,
	"breakWord": `GoalItem-module__break-word___Eayht`,
	"popupClearBtn": `GoalItem-module__popup-clear-btn___N4rRt`,
	"scrollMB20": `GoalItem-module__scroll-m-b-20___BojHi`,
	"container": `GoalItem-module__container___FdK4B`,
	"title": `GoalItem-module__title___TMCFK`,
	"date": `GoalItem-module__date___ncMIH`
};
module.exports = ___CSS_LOADER_EXPORT___;
